import { render, staticRenderFns } from "./ifp-filter-spam.vue?vue&type=template&id=a4c57d3e&"
import script from "./ifp-filter-spam.vue?vue&type=script&lang=ts&"
export * from "./ifp-filter-spam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports